/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedBlurbShipping_shipmentQuote$ref = any;
export type PdpRespSidebarBlurbs_shipmentQuote$ref = any;
export type PdpRespSidebarBlurbs_shipmentQuote = {
    readonly " $fragmentRefs": PdpSharedBlurbShipping_shipmentQuote$ref;
    readonly " $refType": PdpRespSidebarBlurbs_shipmentQuote$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_shipmentQuote",
      "args": null
    }
  ]
};
(node as any).hash = '85984b8f55bab7b2541761aca530b253';
export default node;
